import React, { useEffect, useRef, useState } from 'react'
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, IconButton, Stack, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send'
import SaveIcon from '@mui/icons-material/Save';

import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { useValue } from '../../../context/ContextProvider';
//import { EnviarAddEditDispositivo, actualizarDispositivo } from '../../../actions/Dispositivoes';
import { MuiTelInput } from 'mui-tel-input';
import UsersSelectBox from './UsersSelectBox';
import { useDispositivosMutation } from '../../../hooks/mutations';

const AddEditDispositivo = ({ openDialog, setOpenDialog, isUpdate, selectedRow, usuario }) => {
    const [devId, setDevId] = useState(0);
    const [hwVer, setHwVer] = useState('');
    const [macAdd, setMacAdd] = useState('');
    const [imei, setImei] = useState('');
    const [devCel, setDevCel] = useState('');
    const [devUserId, setDevUserId] = useState('');
    const [devUserName, setDevUserName] = useState('');
    const [devUser, setDevUser] = useState({});
    const commentsRef = useRef();

    const [telfEmpresa, setTelfEmpresa] = useState('');
    const [nombreContacto, setNombreContacto] = useState('');
    const [devUserCel, setDevUserCel] = useState('');
    const [diasVisita, setDiasVisita] = useState([]);
    const [habCheck, setHabCheck] = useState(true);
    const { state: { currentUser, marcas }, dispatch } = useValue();

    const handleUsuarioChange = (textContent, value) => {
        //console.log(value);
        setDevUserId(value);
        //console.log(value);
    }

    useEffect(()=>{
        //console.log(usuario);
        //console.log(selectedRow);
        if(isUpdate) {
            setDevUser({id: selectedRow.devUserId, label: selectedRow.devUserName, cel: usuario.celular});
            setDevId(selectedRow.devId);
            setHwVer(selectedRow.hwVer);
            setMacAdd(selectedRow.macAdd);
            setImei(selectedRow.imei);
            setDevCel(selectedRow.devCel);
            setDevUserId(selectedRow.devUserId);
            setDevUserCel(usuario.celular);
            setHabCheck(selectedRow.enF ? true : false);
        }
    },[selectedRow]);

    /*
    useEffect(() => {
        if(editRowId > 0) {
            setIsUpdate(true);
            //oldRow = Dispositivoes.find((p) => p.id == editRowId);
            oldRow.enF == 1 ? setHabCheck(true) : setHabCheck(false);
            setDevId(oldRow.Dispositivo);
            setTelfEmpresa(oldRow.telfEmpresa);
            setNombreContacto(oldRow.nombreContacto);
            setDevUserCel(oldRow.devUserCel);
            setDiasVisita(oldRow.diasVisita);
            //console.log({oldRow});
        } else {
            setIsUpdate(false);
            setHabCheck(true);
            setDevId('');
            setTelfEmpresa('+591 ');
            setNombreContacto('');
            setDevUserCel('+591 ');
            setDiasVisita('');
            setDiasVisita([]);
        }
        
    }, [openDialog])
    */

    const handleClose = () => {
        setOpenDialog(false);
        //setEditRowId(0);    //Significa ninuna fila editandose
        //console.log(selectedRow);
        if(isUpdate) {
            setDevId(selectedRow.devId);
            setHwVer(selectedRow.hwVer);
            setMacAdd(selectedRow.macAdd);
            setImei(selectedRow.imei);
            setDevCel(selectedRow.devCel);
            setDevUserId(selectedRow.devUserId);
        }

    }

    const dispositivosMutation = useDispositivosMutation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        //console.log(e);
        
        const dispositivo = {
            isUpdate: isUpdate,
            id: isUpdate ? selectedRow.id : 0,
            devId: devId,
            hwVer: hwVer,
            macAdd: macAdd,
            imei: imei,
            devCel: devCel,
            comments: commentsRef.current.value,
            devUserId: devUser.id,
            devUserName: devUser.label,
            enF: habCheck
        }

        //console.log(dispositivo);

        try{
            if(isUpdate == true) {
                await dispositivosMutation.mutateAsync({comando: "CMD_UPDATE_DISPOSITIVO", data: dispositivo});
            } else {
                await dispositivosMutation.mutateAsync({comando: "CMD_CREATE_DISPOSITIVO", data: dispositivo});
            }
            setOpenDialog(false);       //Solo se cierra la ventana si no hay errores y todo salió bien
        } 
        catch (error) {
            //console.log(error);     //Se debe mostrar el mensaje de error al usuario
        }    
    }

    
    const handleAddDispositivo = (dispositivo) => {
        //console.log(dispositivo);
        //createDispositivoMutation.mutate({comando: "CMD_CREATE_DISPOSITIVO", token: currentUser.token, data: dispositivo});
        dispositivosMutation.mutate({comando: "CMD_CREATE_DISPOSITIVO", data: dispositivo, token: currentUser.token});
    }

    const handleTelfEmpresaChange = (newValue) => {
        setTelfEmpresa(newValue)
    }

    const handleTelfChange = (newValue) => {
        setDevUserCel(newValue)
    }

    const handleVisitaFormat = (event, newFormats) => {
        setDiasVisita(newFormats);
    };


    return (
        <Dialog
            open={openDialog}
            onClose={handleClose}
            fullWidth
            maxWidth='sm'
        >
            <DialogTitle>
                {isUpdate ? 'Editar Dispositivo' : 'Nuevo Dispositivo'}
                <IconButton
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    onClick={handleClose}
                >
                    <CancelIcon />
                </IconButton>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                    <DialogContentText paddingBottom={2}>
                        {isUpdate ? 'Puede editar los siguientes campos:' : 'Por favor llene los siguientes campos:'}
                    </DialogContentText>

                    <Divider textAlign="left">Dispositivo</Divider>

                    <Stack direction='row' spacing={2} paddingTop={2} paddingBottom={1}>
                        <TextField
                            autoFocus
                            margin='normal'
                            variant='outlined'
                            id='devId'
                            label='Id del Dispositivo'
                            type='number'
                            fullWidth
                            inputProps={{ minLength: 2, maxLength: 10 }}
                            value={devId}
                            sx={{ width: '50%' }}
                            onChange={(e) => setDevId(e.target.value)}
                            disabled={isUpdate}
                        //helperText='Razón social'
                        />
                        <TextField
                            autoFocus
                            margin='normal'
                            variant='outlined'
                            id='hwV'
                            label='Versión de Hardware'
                            type='number'
                            fullWidth
                            inputProps={{ minLength: 2, maxLength: 10 }}
                            value={hwVer}
                            sx={{ width: '50%' }}
                            onChange={(e) => setHwVer(e.target.value)}
                            disabled={isUpdate}
                        //helperText='Razón social'
                        />
                    </Stack>

                    <Stack direction='row' spacing={2} paddingTop={2} paddingBottom={1}>
                        <TextField
                            autoFocus
                            margin='normal'
                            variant='outlined'
                            id='mac'
                            label='MAC Address'
                            type='text'
                            fullWidth
                            inputProps={{ minLength: 12, maxLength: 17 }}
                            value={macAdd}
                            sx={{ width: '50%' }}
                            onChange={(e) => setMacAdd(e.target.value)}
                            //disabled={!isUpdate}
                        />
                        <TextField
                            autoFocus
                            margin='normal'
                            variant='outlined'
                            id='imei'
                            label='IMEI'
                            type='text'
                            fullWidth
                            inputProps={{ minLength: 10, maxLength: 15 }}
                            value={imei}
                            sx={{ width: '50%' }}
                            onChange={(e) => setImei(e.target.value)}
                            //disabled={!isUpdate}
                        />
                    </Stack>

                    <Stack direction='row' spacing={2} paddingTop={1} paddingBottom={3}>
                        <MuiTelInput
                            label='Cel Dispositivo'
                            value={devCel}
                            sx={{ width: '100%' }}
                            onChange={(e) => setDevCel(e)}
                        />
                    </Stack>

                    <Divider textAlign="left">Usuario del Dispositivo </Divider>

                    <Stack direction='row' spacing={2} paddingTop={2} paddingBottom={3}>
                        <UsersSelectBox 
                            devUser = {devUser}
                            setDevUser = {setDevUser}
                            defaultValue = {selectedRow?.devUserName}
                            //setDevUserId = {setDevUserId}
                            //setDevUserName = {setDevUserName}
                            //defaultUserId = {selectedRow?.devUserId}    
                        />

                        <MuiTelInput disabled value={devUser.cel} label='Cel Contacto' sx={{ width: '60%' }} onChange={handleTelfChange} />
                    </Stack>

                    <Divider textAlign="left">Info adicional</Divider>

                    <Stack direction='row' spacing={2} paddingTop={2}>
                        <TextField
                            margin='normal'
                            variant='outlined'
                            id='com'
                            type='text'
                            label='Comentarios'
                            fullWidth
                            inputRef={commentsRef}
                            inputProps={{ minLength: 10 }}
                            multiline
                            rows={4}
                            defaultValue={isUpdate ? selectedRow?.comments : ''}
                        />

                    </Stack>


                    {isUpdate && <FormControlLabel control={
                        <Checkbox
                            checked={habCheck}
                            onChange={() => setHabCheck(!habCheck)}
                        />
                    } label="Registro habilitado" />}

                </DialogContent>
                <DialogActions sx={{ pr: '22px', pt: '20px' }}>
                    <Button onClick={handleClose} variant="outlined" startIcon={<CancelIcon />}>
                        Cancelar
                    </Button>
                    <Button type='submit' variant='contained' startIcon={<SaveIcon />}>
                        Guardar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>

    )
}

export default AddEditDispositivo

